import GeoJSON from 'ol/format/GeoJSON.js';
import { transform } from 'ol/proj.js';

const DEFAULT_PARENT_ORIGIN = 'https://map.sevenn.be';

function getParentOrigin() {
  const configuredOrigin = new URLSearchParams(window.location.search).get('parentOrigin');

  if (configuredOrigin) {
    try {
      return new URL(configuredOrigin).origin;
    } catch {
      console.warn('Invalid parentOrigin supplied to GIS:', configuredOrigin);
    }
  }

  if (document.referrer) {
    try {
      return new URL(document.referrer).origin;
    } catch {
      // Use the configured default below.
    }
  }

  return DEFAULT_PARENT_ORIGIN;
}

export function geometryToShape(geometry) {
  if (!geometry) return [];

  if (geometry.getType?.() === 'Circle') {
    const [lng, lat] = transform(
      geometry.getCenter(),
      'EPSG:3857',
      'EPSG:4326'
    );

    return {
      type: 'Circle',
      center: { lat, lng },
      radius: geometry.getRadius(),
      radiusUnit: 'meters'
    };
  }

  const geometry4326 = geometry.clone().transform('EPSG:3857', 'EPSG:4326');
  const geometryObject = new GeoJSON().writeGeometryObject(geometry4326);

  if (geometryObject.type === 'Point') {
    return [{
      lat: geometryObject.coordinates[1],
      lng: geometryObject.coordinates[0]
    }];
  }

  const coordinates = geometryObject.type === 'Polygon'
    ? geometryObject.coordinates[0]
    : geometryObject.type === 'MultiPolygon'
      ? geometryObject.coordinates[0]?.[0]
      : geometryObject.coordinates;

  return Array.isArray(coordinates)
    ? coordinates
      .filter(coordinate => Array.isArray(coordinate) && coordinate.length >= 2)
      .map(([lng, lat]) => ({ lat, lng }))
    : [];
}

export function sendPostMessage(type, data) {
  if (window.parent === window) return;

  window.parent.postMessage(
    { type, data },
    getParentOrigin()
  );
}
